import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import SqlEditorWindow from "./SqlEditorWindow/index.vue";
import JobListWindow from './JobListWindow/index.vue'
import AnalysisMenu from './AnalysisMenu.vue'
import { env } from '@/env';

@Component
export class CasModule extends Mixins(ModuleBase) {
  showSqlEditor = false
  showJobList = false

  persistent = {
    sqlPresets: [] as ISqlPreset[],
    memo: {
      releaseName: null as null | string,
      rerun: null as null | string,
    },
  }

  get sqlPresets() {
    return this.persistent.sqlPresets
  }

  get outlet() {
    return {
      window: [SqlEditorWindow, JobListWindow],
      analysisMenu: AnalysisMenu,
    }
  }
}

export interface ISqlPreset {
  name: string
  sql: string
}
